import { render, staticRenderFns } from "./PageTabs.vue?vue&type=template&id=3485e25d"
import script from "./PageTabs.vue?vue&type=script&lang=js"
export * from "./PageTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports